import React from 'react'
import { Button, Fab, Paper, Stack, styled } from '@mui/material'
import { amber, blue, grey } from '@mui/material/colors'
import UpdateIcon from '@mui/icons-material/Update'
import { useGlobalState } from 'state'
import dayjs from 'dayjs'
import { DateTimePicker } from '@mui/x-date-pickers'
import { isPrivateMode } from 'common/consts'

const NowFab = styled(Fab)(() => ({
  backgroundColor: amber[600],
  color: grey[50],
  width: 40,
  height: 40,
  minHeight: 40,
  '&:hover': {
    backgroundColor: amber[500]
  }
}))

export const BaseDateControl = () => {
  const state = useGlobalState()
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [date, setDate] = React.useState(state.app.baseDate.add(9, 'hours'))

  const getMinDateTime = () => {
    if (isPrivateMode) return undefined
    const date = dayjs.utc().subtract(1, 'month')
    const limit = dayjs.utc('2025/05/20 00:00', 'YYYY/MM/DD HH:mm')
    if (date < limit) {
      return limit
    } else {
      return date.subtract(date.hour(), 'hour').subtract(date.minute(), 'minute').subtract(date.second(), 'second')
    }
  }

  const moveNow = () => {
    state.app.setBaseDate(dayjs.utc())
  }

  React.useEffect(() => {
    const d = state.app.baseDate.add(9, 'hours')
    setDate(d.subtract(d.minute() % 5, 'minutes'))
  }, [state.app.baseDate])

  const onAccept = (date: any) => {
    state.app.setBaseDate(date.subtract(9, 'hours'))
  }

  const onClose = () => {
    setDialogOpen(false)
  }

  return (
    <>
      <Stack direction="column" alignItems={'center'} spacing={1}>
        <NowFab onClick={moveNow}>
          <UpdateIcon />
        </NowFab>
        <DateTimePicker
          value={date}
          open={dialogOpen}
          minDateTime={getMinDateTime()}
          maxDateTime={dayjs.utc().add(9, 'hours')}
          reduceAnimations
          sx={{visibility: 'hidden', maxHeight: '0px'}}
          minutesStep={5}
          onAccept={onAccept}
          onClose={onClose}
        />
        <Paper sx={{width: 120, backgroundColor: blue[700], color: grey[200], textAlign: 'center', borderRadius: '20px'}}>
          <Button size='small' sx={{px: 0, py: '1px'}} color='inherit' disableRipple onClick={() => setDialogOpen(true)}>
            { state.app.baseDate.local().format('YYYY/MM/DD HH:mm') }
          </Button>
        </Paper>
      </Stack>
    </>
  )
}
